import { DocumentsAction } from './alldocuments-actions.model';

export const DOCUMENTS_ACTIONS: DocumentsAction[] = [
  { id: 0, styleClass: "bg-danger", label: 'allDocuments.actions.clearMessages', icon: 'pi pi-times', visible: false },
  { id: 1, styleClass: "bg-primary", label: 'allDocuments.actions.newDocument', icon: 'pi pi-file' },
  { id: 2, styleClass: "p-button-secondary", label: 'allDocuments.actions.exportPdf', icon: 'pi pi-download' },
  { id: 3, styleClass: "bg-danger", label: 'allDocuments.actions.clearFilters', icon: 'pi pi-filter-slash' },
  { id: 4, styleClass: "bg-info", label: 'allDocuments.actions.resetColumns', icon: 'pi pi-sort-alt-slash' }
];
